/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_Supported_Formats_LabelInputs */

const en_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supported formats: JSON, EDL`)
};

const fr_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formats pris en charge : JSON, EDL`)
};

const de_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstützte Formate: JSON, EDL`)
};

const it_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formati supportati: JSON, EDL`)
};

const ru_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддерживаемые форматы: JSON, EDL`)
};

const es_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos admitidos: JSON, EDL`)
};

const zh_cn2_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持的格式：JSON、EDL`)
};

const ja_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サポートされている形式: JSON、EDL`)
};

const hi_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समर्थित प्रारूप: JSON, EDL`)
};

const pt_pt2_marker_import_supported_formats_label = /** @type {(inputs: Marker_Import_Supported_Formats_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatos suportados: JSON, EDL`)
};

/**
* | output |
* | --- |
* | "Supported formats: JSON, EDL" |
*
* @param {Marker_Import_Supported_Formats_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_supported_formats_label = /** @type {((inputs?: Marker_Import_Supported_Formats_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_Supported_Formats_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_import_supported_formats_label(inputs)
	if (locale === "de") return de_marker_import_supported_formats_label(inputs)
	if (locale === "it") return it_marker_import_supported_formats_label(inputs)
	if (locale === "ru") return ru_marker_import_supported_formats_label(inputs)
	if (locale === "es") return es_marker_import_supported_formats_label(inputs)
	if (locale === "zh-CN") return zh_cn2_marker_import_supported_formats_label(inputs)
	if (locale === "ja") return ja_marker_import_supported_formats_label(inputs)
	if (locale === "hi") return hi_marker_import_supported_formats_label(inputs)
	if (locale === "pt-PT") return pt_pt2_marker_import_supported_formats_label(inputs)
	return en_marker_import_supported_formats_label(inputs)
});